export function initFlyoutScroll(): void {
    const nav = document.querySelector<HTMLElement>('.flyout');
    if (!nav) return;

    const baseTop = parseFloat(getComputedStyle(nav).top) || 0;
    let ticking = false;

    function updateTop(): void {
        const newTop = Math.max(0, baseTop - window.scrollY);
        nav!.style.top = `${newTop}px`;
        ticking = false;
    }

    updateTop();

    window.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(updateTop);
    }, { passive: true });
}
